import { render, staticRenderFns } from "./DeleteTemplateAlert.vue?vue&type=template&id=621200b7"
import script from "./DeleteTemplateAlert.vue?vue&type=script&lang=js"
export * from "./DeleteTemplateAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports